/**
 * 手機號碼頁的價值點清單（QR / 傳單共用）。
 *
 * 擺在輸入框與送出鍵「之下」：小螢幕開鍵盤後這一區會落在摺線以下，
 * 屬於補充說明，不可放主要操作。用細線與上方表單分組（沿用首頁做法，不加卡片外框）。
 *
 * 文案分寸：用量預測需累積足夠叫桶筆數才會算（見 Home「紀錄還太少，暫時無法計算」），
 * 故第一項寫「用過幾次後」而非直接承諾，避免新客戶期待落差。
 */
const ITEMS: { icon: JSX.Element; title: string; desc: string }[] = [
  {
    icon: (
      <path d="M12 3.5v4M12 3.5a8.5 8.5 0 108.5 8.5" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
    ),
    title: "算出您家的用量",
    desc: "用過幾次後，系統會算出平均幾天一桶",
  },
  {
    icon: (
      <>
        <path d="M6 10a6 6 0 1112 0c0 4 1.4 5.4 1.4 5.4H4.6S6 14 6 10z" stroke="currentColor" strokeWidth="1.9" strokeLinejoin="round" />
        <path d="M10 18.5a2 2 0 004 0" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
      </>
    ),
    title: "快用完前先提醒",
    desc: "不會洗到一半才發現沒瓦斯",
  },
  {
    icon: (
      <>
        <path d="M4.5 12a7.5 7.5 0 1112.6 5.5" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
        <path d="M4.5 7.5V12h4.5" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
      </>
    ),
    title: "一鍵重複上次",
    desc: "規格、安裝位置都不用重選",
  },
];

const LandingValues = () => (
  <div className="mt-6 pt-[18px] border-t border-[#EEF2F7] flex flex-col gap-[15px]">
    {ITEMS.map((it) => (
      <div key={it.title} className="flex gap-[11px] items-start">
        <div className="w-[30px] h-[30px] rounded-[9px] bg-[#EAF4FE] text-[#1565C0] flex items-center justify-center shrink-0">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">{it.icon}</svg>
        </div>
        <div className="flex-1 min-w-0 pt-px">
          <div className="text-[13.5px] font-extrabold text-[#0f1a35] leading-[1.4]">{it.title}</div>
          <div className="text-[12px] text-[#64748B] leading-[1.6] mt-0.5">{it.desc}</div>
        </div>
      </div>
    ))}
  </div>
);

export default LandingValues;
